import React, { Component } from 'react'
import { Layout, Typography, Form, Input, Button, Spin, notification } from 'antd';
import { sessionManager } from '../../core/SessionManager';
import styles from './login.module.css';
import { post } from '../../utils/http';
import api from '../../utils/api';
import { LoadingOutlined } from '@ant-design/icons';

const { Title } = Typography;
const { Content } = Layout;

class AddMerchant extends Component {
    constructor(props) {
        super(props);
        this.state = ({
            userId: sessionManager.getUserId(),
            loading: false,
            mobilenumber: "",
            password: "",
            merchantName: "",
        })
    }

    goBack = () => {
        let _this = this
        post(api.removePrivilege).then(function (response) {
            _this.removePrivilege()
        }).catch(function (error) {
            _this.removePrivilege()
        })
    };

    removePrivilege = () => {
        sessionManager.signout();
        this.props.history.push('./login')
    }

    addMerchant = () => {
        const { userId, mobilenumber, password, merchantName } = this.state;
        this.setState({
            loading: true
        })
        let confirmData = {
            userId: userId,
            mobileNumber: mobilenumber,
            password: password,
            merchantName: merchantName,
        }
        var _this = this;
        let merchantId;
        post(api.addMerchant, confirmData).then(function (response) {
            var confirmData = new FormData();
            merchantId = response.merchantId;
            var userInfot = sessionManager.getUserInfo();
            console.log('userInfot',userInfot);
            console.log('storelist',response.storeList);
            userInfot.storeList = response.storeList;
            sessionManager.setUserInfo(userInfot);
            sessionManager.setMerchantId(merchantId);
            sessionManager.setMerchantName(merchantName);
            confirmData.append("merchantId", merchantId);
		    post(api.telepinDoLogin, confirmData).then(function(response){
			    sessionManager.setPrivilege(response.privilege);
			    sessionManager.setIsAdmin(response.isAdmin);
			    sessionManager.setMerchant(response.merchant);
			    sessionManager.setIsSMRTNonCFOUser(response.isSMRTNonCFOUser);
			    sessionManager.setNeedChangePassword(response.needChangePassword);
			    sessionManager.setTemporaryPassword(response.temporaryPassword);
			    sessionManager.setUserAuthenticatedTime(response.userAuthenticatedTime);
                sessionManager.setMerchantName(response.merchantName);
                var confirmData1 = new FormData();
                confirmData1.append("merchantId", merchantId);
                confirmData1.append("userRole", 3);
                post(api.getMenuList, confirmData1).then(function (response) {
                    sessionManager.setMenuList(response);
                    _this.setState({ loading: false }, () => {
                        _this.props.history.push('./page/home')
                    });
                }).catch(function (error) {
                    notification['error']({
                        message: error
                    })
                    _this.setState({ loading: false });
                })
		    }).catch(function(error){
			    console.log(error);
                _this.setState({ loading: false });
                notification['error']({
                    message: 'Fail to login.',
                });
		    })
        }).catch(function (error) {
            notification['error']({
                message: error,
            });
            _this.setState({ loading: false })
        });
    }

    handleMobilenumber = (e) => {
        this.setState({
            mobilenumber: e.target.value
        })
    }

    handlePassword = (e) => {
        this.setState({
            password: e.target.value
        })
    }

    handleMerchantName = (e) => {
        this.setState({
            merchantName: e.target.value
        })
    }

    render() {
        return (
            <>
                <Layout style={{ background: 'white', paddingTop: '200px', width: 600, marginLeft:'auto', marginTop:0, marginRight:'auto', marginBottom:0 }}>
                    <Content style={{ textAlign: 'center' }}>
                        <Title>Add merchant</Title>
                        
                        <Form name="basic" autoComplete="off" labelCol={{ span: 6 }} wrapperCol={{ span: 16 }} style={{ textAlign: 'center' }} >
                            <Form.Item label="Merchant Name" name="merchantName" rules={[{ required: true, message: 'Please input your Merchant Name!' }]}>
                                <Input size="large" className={styles.input} onChange={this.handleMerchantName} />
                            </Form.Item>
                            <Form.Item label="Mobile Number" name="mobilenumber" rules={[{ required: true, message: 'Please input your Mobile Number!' }]}>
                                <Input size="large" className={styles.input} onChange={this.handleMobilenumber} />
                            </Form.Item>
                            <Form.Item label="Password" name="password" rules={[{ required: true, message: 'Please input your Password!' }]}>
                                <Input size="large" className={styles.input} onChange={this.handlePassword} />
                            </Form.Item>
                            <div style={{ marginTop: '50px' }}>
                                {!this.state.loading && <Button type="primary" onClick={this.addMerchant}>Add</Button>}
                                {this.state.loading && <Spin indicator={<LoadingOutlined style={{ fontSize: 24, color: "#a52387" }} spin />} />}
                                    <Button onClick={this.goBack} style={{ marginLeft: '30px' }}>
                                        LOGOUT
                                    </Button>
                            </div>
                        </Form>
                    </Content>
                </Layout>
            </>
        );

    }

};
export default AddMerchant;